import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Import pages
import Footer from "./components/Footer";
import NavBar from "./components/NavBar";
import SiteMetadata from "./components/SiteMetadata";
import FrontPage from "./pages/Frontpage";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Experience from "./pages/Experience";
import Education from "./pages/Education";
import "./App.css";

// Import internalization
import "./i18n";
import Skills from "./pages/Skills";

function App() {
  const { t } = useTranslation();

  return (
    <div className="App">
      <a className="skipLink" href="#main-content">{t("accessibility.skipToContent")}</a>
      <BrowserRouter>
        <SiteMetadata />
        <NavBar />
          <div className="content" id="main-content" tabIndex="-1">
            <Routes>
              <Route  path="/" element={<FrontPage />}/>
              <Route path="/about" element={<About />}/>
              <Route path="/contact" element={<Contact />}/>
              <Route path="/education" element={<Education />}/>
              <Route path="/experience" element={<Experience />}/>
              <Route path="/skills" element={<Skills />}/>
              {[
                ["/About", "/about"],
                ["/Contact", "/contact"],
                ["/Education", "/education"],
                ["/Experience", "/experience"],
                ["/Skills", "/skills"],
              ].map(([from, to]) => (
                <Route key={from} path={from} element={<Navigate replace to={to} />} />
              ))}
              <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
          </div>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
